<template>
  <div class="highlight">
    <div>
      <i
        class="hi hi-right-arrow"
        :style="styles.arrow"
      ></i>
      <span
        class="highlight-name"
        :style="styles.text"
      >
        {{ metric }}
      </span>
    </div>
    <div
      class="highlight-description"
      @mouseover="handleHover(true, $event)"
      @mouseleave="handleHover(false, $event)"
      @click="openDialog"
    >
      Average {{ computedTimeFrame.current }} was
      <span :style="styles.text"> {{ percentage }} {{ trend }} </span>
      than <strong>{{ benchmark }}</strong> average over the {{ computedTimeFrame.previous }}.
    </div>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsPerformanceHighlightsHighlight',
  props: {
    highlight: {
      type: Object,
      required: true,
    },
    timeFrame: {
      type: String,
      required: true,
    },
  },
  computed: {
    direction() {
      return Math.sign(this.highlight.change) === 1 ? 'ascending' : 'descending';
    },
    styles() {
      return INSIGHTS.performanceHighlights.styles[this.direction];
    },
    computedTimeFrame() {
      return INSIGHTS.performanceHighlights.labels.timeFrame[this.timeFrame];
    },
    trend() {
      return INSIGHTS.performanceHighlights.labels.trend[this.direction];
    },
    metric() {
      return INSIGHTS.performanceHighlights.labels.metric[this.highlight.metric];
    },
    percentage() {
      return `${Math.abs(this.highlight.change)}%`;
    },
    benchmark() {
      return 'their own';

      // Benchmarks will be added in the next milestone;
      // return this.highlight.benchmark;
    },
  },
  methods: {
    handleHover(isHovered) {
      this.$emit('hovered', isHovered);
    },
    openDialog() {
      this.$emit('openDialog');
    },
  },
};
</script>
